var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18V14.1206H2.25C1.65326 14.1206 1.08095 13.8857 0.658997 13.4675C0.23704 13.0494 0 12.4823 0 11.891V2.22956C0 1.63825 0.23704 1.07114 0.658997 0.653011C1.08095 0.234887 1.65326 0 2.25 0H15.75C16.3467 0 16.919 0.234887 17.341 0.653011C17.7629 1.07114 18 1.63825 18 2.22956V11.891C18 12.4823 17.7629 13.0494 17.341 13.4675C16.919 13.8857 16.3467 14.1206 15.75 14.1206H7.41L3 18ZM2.25 1.48638C2.05109 1.48638 1.86029 1.56466 1.71964 1.70404C1.57898 1.84341 1.5 2.03246 1.5 2.22956V11.891C1.5 12.0881 1.57898 12.2771 1.71964 12.4165C1.86029 12.5559 2.05109 12.6342 2.25 12.6342H4.5V14.6928L6.84 12.6342H15.75C15.9489 12.6342 16.1397 12.5559 16.2803 12.4165C16.421 12.2771 16.5 12.0881 16.5 11.891V2.22956C16.5 2.03246 16.421 1.84341 16.2803 1.70404C16.1397 1.56466 15.9489 1.48638 15.75 1.48638H2.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H4V11H5V7Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H7V11H8V9Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H10V11H11V3Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H13V11H14V5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountent);
export default __webpack_public_path__ + "static/media/Accountent.0f030f753c9745d015de58ef65140b55.svg";
export { ForwardRef as ReactComponent };